import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PropertyListingCreateRequestDTO,
  PropertyListingDeleteRequestDTO,
  PropertyListingDTO,
  PropertyListingList,
  PropertyListingReadAllPaginatedRequestDTO,
  PropertyListingReadByIdRequestDTO,
  PropertyListingReadByPropertyIdRequestDTO,
  PropertyListingReadAllPaginatedResponseList,
  PropertyListingUpdateRequestDTO,
  PropertyListingGetPropertyDetailsRequestDTO,
  PropertyListingGetPropertyDetailsResponseDTO,
  PropertyListingCompareListingsRequestDTO,
  PropertyListingGetPropertyDetailsResponseList,
  PropertyListingReadAllPaginatedForAdminRequestDTO,
  PropertyListingReadAllPaginatedForAdminResponseList,
} from './property-listing.interface';

import {
  PropertyListing_CompareListings,
  PropertyListing_Create,
  PropertyListing_Delete,
  PropertyListing_GetPropertyDetails,
  PropertyListing_ReadAll,
  PropertyListing_ReadAllPaginated,
  PropertyListing_ReadAllPaginatedForAdmin,
  PropertyListing_ReadById,
  PropertyListing_ReadByPropertyId,
  PropertyListing_Update
} from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root',
})
export class PropertyListingService {
  private http = inject(HttpClient);

  PropertyListing_ReadAll(): Observable<PropertyListingList> {
    return this.http.get<PropertyListingList>(PropertyListing_ReadAll);
  }

  PropertyListing_Create(data: PropertyListingCreateRequestDTO): Observable<PropertyListingDTO> {
    return this.http.post<PropertyListingDTO>(PropertyListing_Create, data);
  }

  PropertyListing_Update(data: PropertyListingUpdateRequestDTO): Observable<PropertyListingDTO> {
    return this.http.post<PropertyListingDTO>(PropertyListing_Update, data);
  }

  PropertyListing_Delete(data: PropertyListingDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PropertyListing_Delete, data);
  }

  PropertyListing_ReadById(data: PropertyListingReadByIdRequestDTO): Observable<PropertyListingDTO> {
    return this.http.post<PropertyListingDTO>(PropertyListing_ReadById, data);
  }

  PropertyListing_ReadByPropertyId(data: PropertyListingReadByPropertyIdRequestDTO): Observable<PropertyListingDTO> {
    return this.http.post<PropertyListingDTO>(PropertyListing_ReadByPropertyId, data);
  }

  PropertyListing_ReadAllPaginated(data: PropertyListingReadAllPaginatedRequestDTO): Observable<PropertyListingReadAllPaginatedResponseList> {
    return this.http.post<PropertyListingReadAllPaginatedResponseList>(PropertyListing_ReadAllPaginated, data);
  }

  PropertyListing_ReadAllPaginatedForAdmin(data: PropertyListingReadAllPaginatedForAdminRequestDTO): Observable<PropertyListingReadAllPaginatedForAdminResponseList> {
    return this.http.post<PropertyListingReadAllPaginatedForAdminResponseList>(PropertyListing_ReadAllPaginatedForAdmin, data);
  }

  PropertyListing_GetPropertyDetails(data: PropertyListingGetPropertyDetailsRequestDTO): Observable<PropertyListingGetPropertyDetailsResponseDTO> {
    return this.http.post<PropertyListingGetPropertyDetailsResponseDTO>(PropertyListing_GetPropertyDetails, data);
  }

  PropertyListing_CompareListings(data: PropertyListingCompareListingsRequestDTO): Observable<PropertyListingGetPropertyDetailsResponseList> {
    return this.http.post<PropertyListingGetPropertyDetailsResponseList>(PropertyListing_CompareListings, data);
  }
}
